module.exports = __webpack_public_path__ + "img/潘老师-1.7b2610f9.png";